<!--
 * @Description: 子账户列表
 * @Date: 2019-12-28 12:49:18
 * @LastEditTime: 2021-06-04 15:47:01
 -->
<template>
  <div id="subAccountList">
    <!-- S 表格筛选 -->
    <TableSearch
      ref="TableSearch"
      v-model="searchForm"
      :options="searchOptions"
      :show-toggle="true"
      @submit="setSearch"
    >
      <div slot="button" class="btn-group">
        <div class="btn-item">
          <el-button type="primary" icon="el-icon-plus" @click="createVisible = true">
            添加子账户
          </el-button>
        </div>
      </div>
      <!-- /表格操作 -->
    </TableSearch>
    <!-- E 表格筛选 -->
    <!-- S 表格 -->
    <div class="forensic-table-wrap">
      <el-table
        v-loading="items.loading"
        class="list-table"
        :data="items.data"
        :auto-upload="false"
        tooltip-effect="dark"
        stripe
      >
        <el-table-column
          prop="username"
          label="账号"
          align="center"
          show-overflow-tooltip
        />
        <el-table-column prop="email" label="邮箱" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.email || "— —" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.remark || "— —" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="小程序码" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <img src="../../assets/imgs/ercode.jpg" class="mp-code" width="30" height="30" title="点击预览" alt="" @click="handlePreviewImg(scope.row)">
          </template>
        </el-table-column>
        <el-table-column prop="lastLoginTime" label="最近登录时间" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.lastLoginTime || "— —" }}</span>
          </template>
        </el-table-column>
        <el-table-column width="180" label="操作" prop="status" align="center">
          <template slot-scope="scope">
            <div class="table-operate-wrap">
              <el-button
                v-if="scope.row.status === '禁用'"
                type="primary"
                @click.native.prevent="handleRemove(scope.row, 1)"
              >
                恢复
              </el-button>
              <el-button
                v-if="scope.row.status === '启用'"
                type="primary"
                @click.native.prevent="handleEdit(scope.row)"
              >
                编辑
              </el-button>
              <el-button
                v-if="scope.row.status === '启用'"
                @click.native.prevent="handleRemove(scope.row, 2)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="items.total"
        class="pagination-wrap"
        background
        :current-page="items.pageNum"
        :page-size="items.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="items.total"
        @size-change="setPageSize"
        @current-change="setPageNum"
      />
    </div>
    <!-- S 创建 -->
    <SubAccountCreate v-model="createVisible"/>
    <!-- E 创建 -->

    <!-- S 修改 -->
    <SubAccountEdit v-model="editVisible" :item="item" />
    <!-- E 修改 -->

    <!-- S 图片预览 -->
    <PreviewImg ref="preview" />
    <!-- E 图片预览 -->
    <!-- <canvas ref="canvas"></canvas> -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { TableSearch, PreviewImg } from '@/components'
import SubAccountCreate from './subAccountCreate'
import SubAccountEdit from './subAccountEdit'
import { getCanvas } from '@/utils/tools'
import { getMiniProgramCode } from '@/api/account'
const loading = require('../../assets/imgs/lazy/mp_code_loading.jpg')
const error = require('../../assets/imgs/lazy/mp_code_error.jpg')

export default {
  components: { TableSearch, SubAccountCreate, SubAccountEdit, PreviewImg },
  data() {
    return {
      searchForm: {},
      searchOptions: [
        {
          field: 'userName',
          label: '账号',
          placeholder: '',
          type: 'input'
        },
        {
          field: 'email',
          label: '邮箱',
          placeholder: '',
          type: 'input'
        }
        ],
      createVisible: false,
      editVisible: false,
      item: {},
      loading: loading,
      error: error,
      imgUrl: '',
    };
  },
  computed: {
    ...mapState({
      items: state => state.account.items
    })
  },
  watch: {},
  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions({
      getList: 'account/getList',
      setSearch: 'account/setSearch',
      setPageNum: 'account/setPageNum',
      setPageSize: 'account/setPageSize',
      setSort: 'account/setSort',
      remove: 'account/remove'
    }),
    // 修改
    handleEdit(row) {
      this.editVisible = true
      this.item = row
      debugger
    },
    // 删除
    handleRemove(row, type) {
      const msg = type === 2 ? '删除' : '恢复'
      this.$confirm('您确定要' + msg + '该子账号吗？', `${msg}`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(() => {
        this.remove({ userId: row.userId, type }).then(res => {
          this.$message({
            type: 'success',
            message: `${msg}成功`,
            center: true
          })
        })
      })
    },
    // 图片预览
    handlePreviewImg(row) {
      getMiniProgramCode(row.userId).then(res => {
        const {data} = res.data
        this.getImgurl(`data:image/jpeg;base64,${data}`)
      })
    },
    getImgurl(url){
      const image = new Image()
      image.src = url
      image.onload = async () =>{
        this.imgUrl = await getCanvas(image,image.width,image.height)
        this.$refs.preview.src = this.imgUrl
        this.$refs.preview.visible = true
      }
    }
  }
};
</script>
<style lang="scss">
#subAccountList {
  .el-table thead th {
    padding: 14px 0;
  }
  .mp-code {
    cursor: pointer;
  }
  .btn-group {
    display: flex;
    align-items: center;
    flex-flow: row wrap;
    .el-button {
      width: 120px;
      height: 40px;
      padding: 0;
    }
    .btn-item {
      margin-right: 10px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
